<template>
  <b-modal id="modal-alert" ref="modal" title="Upozornění" centered ok-only @ok="onOk">
    {{ message }}
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      message: '',         // Text hlášky
      callback: null,      // Funkce, která se zavolá po zavření
    };
  },
  methods: {
    show(message, callback = null) {
      this.message = message;
      this.callback = callback;
      this.$refs.modal.show();
    },
    onOk() {
      if (this.callback) {
        this.callback();
      }
    }
  }
};
</script>